export function strToNum(arr) {
  return arr.map((item) => {
    const v = item.value;

    // ⭐ 避免 Number(null) = 0
    if (v === null || v === undefined) {
      return { ...item, value: null };
    }

    // ⭐ 空字串 → null
    if (v === "") {
      return { ...item, value: null };
    }

    // ⭐ 無法轉數字 → null
    const num = Number(v);
    if (isNaN(num)) {
      return { ...item, value: null };
    }

    // ⭐ 可以轉數字 → 轉成數字
    return { ...item, value: num };
  });
}
